import React from 'react';
import TextCell from '../../../views/components/cells/TextCell';
import ComparisonItemType from '@/types/comparison-item-type';

export class ProposalFieldDAO {
  /**
   * Value of the field
   */
  value: any; // TODO - make this type-safe (remove any)

  /**
   * Label of the field
   */
  label: string;

  /**
   * Cell type
   */
  cellType: React.FC<any>; // TODO - make this type-safe (remove any)

  /**
   * cell format
   */
  cellFormat?: string;

  /**
   * Use number suffixes
   */
  withSuffixes?: boolean;

  /**
   * key of the field - not translated
   */
  key?: string;

  /**
   * icon name for the field
   */
  icon?: string;

  /**
   * icon color for the field
   */
  color?: string;

  /**
   * comparison item type for the field
   */
  itemType?: ComparisonItemType;

  /**
   * class name for the field
   */
  className?: string;

  /**
   * currency for the field
   */
  currency?: string;

  /**
   * number of decimal Places for the field
   */
  decimalPlace?: number;

  /**
   * colspan for the field
   */
  colSpan?: number;

  /**
   * disclaimer for the field
   */
  hasDisclaimer?: boolean;

  /**
   * disclaimer number for sequential numbering (e.g., [1], [2], [3]) used for Trailing Returns
   */
  disclaimerNumber?: number;

  /**
   * disclaimer key for a11y id used for Trailing Returns
   */
  disclaimerKey?: string;

  /**
   * section key for a11y id used for Trailing Returns
   */
  sectionKey?: string;

  /**
   * asterisk disclaimer key for a11y id used for Trailing Returns
   */
  asteriskDisclaimerKey?: string;

  flags?: string[];

  constructor(label: string, value: any, className?: string, cellType: React.FC<any> = TextCell) {
    this.label = label;
    this.value = value;
    this.className = className;
    this.cellType = cellType;
  }
}
